import {
  AxiomReportType,
  AxiomReportTypeFullNames,
} from '@/enums/axiom-report.enum'
import dayjs from 'dayjs'
import { isNaN, isNull, isUndefined, orderBy } from 'lodash'

/**
 * A generic utility Function to Remove an object from array of objects by matching provided key
 * @param array
 * @param obj
 * @param key
 * @returns array
 */
export const removeObjectFromArray = (array: any[], obj: any, key: string) => {
  // Check if obj and key are provided and obj has the key property
  if (!obj || !key || typeof obj[key] === 'undefined') {
    return array
  }

  // Use filter to create a new array without the object
  const newArray = array.filter((item: any) => item[key] !== obj[key])

  return newArray
}

export const getReportTypeTitle = (reportType: AxiomReportType): string => {
  return AxiomReportTypeFullNames[reportType] || 'Unknown Report Type'
}
export const formatNumber = (
  num: any,
  isShowNA?: boolean,
  minFractionDigits?: number,
  maxFractionDigits?: number,
) => {
  if (!isFinite(num) || isNaN(num) || isUndefined(num) || isNull(num)) {
    if (isShowNA) {
      return 'N/A'
    } else {
      return num
    }
  }

  if (num === '') return '' // Return empty string if input is empty

  // Check if input is a non-numeric string
  if (typeof num === 'string' && isNaN(Number(num))) {
    return num // If it's a non-numeric string, return it as is
  }

  const value = Number(num)
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits:
      minFractionDigits !== undefined ? minFractionDigits : 3,
    maximumFractionDigits:
      maxFractionDigits !== undefined ? maxFractionDigits : 3,
  }).format(value)
}

export const checkVariantsInKey = (data: any[], key: string) =>
  Boolean(Array.from(new Set(data?.map((item) => item[key])))?.length > 1)

export const sortArray = (
  array: any[],
  orderKey: string,
  orderSequence?: 'asc' | 'desc',
) => {
  return orderBy(array, [orderKey], [orderSequence || 'asc'])
}

export const removeCommaFromString = (value: string) => value.replace(/,/g, '')

export const escapeSpecialCharacters = (str: string): string => {
  return str?.replace(/[<>&"?]/g, function (match: string) {
    switch (match) {
      case '<':
        return '&lt;'
      case '>':
        return '&gt;'
      case '?':
        return '&quest;'
      case '&':
        return '&amp;'
      case '"':
        return '&quot;'
      default:
        return match
    }
  })
}

export const formatCurrency = (
  value: number,
  locale = 'en-US',
  currency = 'USD',
) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(value)
}

export const getLatestDate = (dates: string[]) => {
  return dates.reduce((a, b) => {
    return dayjs(a).isAfter(dayjs(b)) ? a : b
  })
}

export const countDecimalPlaces = (value: number) => {
  const str = value.toString()
  const parts = str.split('.')
  return parts[1] ? parts[1].length : 0
}
